import React from "react";

const ShowIJMB = ({ r }) => {
  const {
    institutionName,
    yearOfGraduation,
    educationSubject,
    educationSubjectGrade,
    educationSubject2,
    educationSubject2Grade,
    educationSubject3,
    educationSubject3Grade,
  } = r?.results;
  return (
    <>
      <div className="row my-2">
        <div className="col-md-4">Institution</div>
        <div className="col-md-8">{institutionName}</div>
      </div>
      <div className="row my-2">
        <div className="col-md-4">Graduation Year</div>
        <div className="col-md-8">{yearOfGraduation}</div>
      </div>
      <div className="row my-2 ">
        <div className="col-md-4">Subject 1</div>
        <div className="col-md-4">{educationSubject}</div>
        <div className="col-md-4">{educationSubjectGrade}</div>
      </div>
      <div className="row my-2 ">
        <div className="col-md-4">Subject 2</div>
        <div className="col-md-4">{educationSubject2}</div>
        <div className="col-md-4">{educationSubject2Grade}</div>
      </div>
      <div className="row my-2 ">
        <div className="col-md-4">Subject 3</div>
        <div className="col-md-4">{educationSubject3}</div>
        <div className="col-md-4">{educationSubject3Grade}</div>
      </div>
    </>
  );
};

export default ShowIJMB;
